jQuery( function ( $ ) {
	$( '.slider-range' ).each( function () {
		const slider = $( this );

		let slider_range_html = slider.parent( '.wpas-html' ).children( '.label-container' ).append( '<div class="text-right"/>' ).find( 'div' );
		let min = slider.data( 'min' );
		let max = slider.data( 'max' );
		let unit = slider.data( 'unit' );

		slider.slider( {
			range: true,
			min: min,
			max: max,
			values: [ min, max ],
			step: slider.data( 'step' ),
			slide: function ( event, ui ) {
				let id = '#meta_' + $( this ).attr( 'id' );

				$( id + '1' ).val( ui.values[0] );
				$( id + '2' ).val( ui.values[1] );

				update_slider_range_html( slider_range_html, ui.values[0], ui.values[1], unit );
			},
			stop: function ( event, ui ) {
				$( '#wp-advanced-search' ).trigger( 'submit' );
			},
		} );

		update_slider_range_html( slider_range_html, min, max, unit );
	} );

	function update_slider_range_html( element, min, max, unit ) {
		element.html( min.toLocaleString( 'nb' ) + ' ' + unit + ' - ' + max.toLocaleString( 'nb' ) + ' ' + unit );
	}
} );
